import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Nav = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    gap: 4rem;
    margin-top: 8rem;
    align-items: center;

    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      margin-top: 3rem;
      gap: 3rem;
    }
  `,

  BtnWrapper: styled.div`
    display: flex;
    gap: 1rem;
  `,
  Btn: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.5rem 4rem;
    background-color: ${(props) => (props.selected ? "#2A4CFF" : "#ECECEC")};
    color: ${(props) => (props.selected ? "white" : "#AAA")};
    font-size: 2.2rem;
    font-weight: 500;
    border-radius: 1rem;
    cursor: pointer;

    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      padding: 1.3rem 1.5rem;
      font-size: 1.8rem;
    }
  `,
  Text: styled.div`
    text-align: center;
    font-size: 2.2rem;
    font-weight: 450;
    position: relative;
    text-decoration-line: 1.5rem #cbfff3;

    z-index: 2;

    width: fit-content;
    & > div {
      background-color: #cbfff3;
      position: absolute;
      width: 100%;
      height: 1.5rem;
      top: 50%;
      z-index: -1;
    }

    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      font-size: 1.7rem;
    }
  `,
};
